interface ShareInfo {
  name: string;
  description?: string;
  image?: string;

  shareTitle?: string;
  shareDescription?: string;
  shareImage?: string;
}

interface ProjectInfo {
  name: string;
  description?: string | { text?: string };
  icon?: string;

  shareImage?: string;
}

export const getPageMetadata = (
  project: ProjectInfo,
  game?: ShareInfo,
  qr?: ShareInfo
) => {
  return {
    title: getMetaTitle(project, game, qr),
    description: getMetaDescription(project, game, qr),
    image: getMetaImage(project, game, qr),
    domain: "web.intractive.app",
  };
};

const getMetaTitle = (
  project: ProjectInfo,
  game?: ShareInfo,
  qr?: ShareInfo
) => {
  if (qr?.shareTitle) return qr.shareTitle;

  if (game?.shareTitle) return game.shareTitle;

  if (game?.name) return game.name;

  return project.name;
};

const getMetaDescription = (
  project: ProjectInfo,
  game?: ShareInfo,
  qr?: ShareInfo
) => {
  if (qr?.shareDescription) return qr.shareDescription;
  if (game?.shareDescription) return game.shareDescription;

  if (game?.description) return game.description;

  return project.description;
};

const getMetaImage = (
  project: ProjectInfo,
  game?: ShareInfo,
  qr?: ShareInfo
) => {
  if (qr?.shareImage) return qr.shareImage;
  if (game?.shareImage) return game.shareImage;
  if (game?.image) return game.image;

  return project.shareImage || project.icon;
};
